// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1itaz","wrapper":"Home_wrapper__3iQLr","section":"Home_section__s2Msu"};